const userTypes = {
	SESSION: {
		SELECT_BUSINESS: 'USER_SELECT_BUSINESS',
		LOGOUT: 'USER_LOGOUT',
	},

	LOGIN: {
		REUQEST: 'USER_LOGIN_REQUEST',
		SUCCESS: 'USER_LOGIN_SUCCESS',
		FAILURE: 'USER_LOGIN_FAILURE',
	},

	ASNAAF_OTP: {
		REQUEST: 'ASNAAF_OTP_REQUEST',
		SUCCESS: 'ASNAAF_OTP_SUCCESS',
		FAILURE: 'ASNAAF_OTP_FAILURE',
		CLEAR: 'ASNAAF_OTP_CLEAR',
	},

	ASNAAF_LOGIN: {
		REQUEST: 'ASNAAF_LOGIN_REQUEST',
		SUCCESS: 'ASNAAF_LOGIN_SUCCESS',
		FAILURE: 'ASNAAF_LOGIN_FAILURE',
		CLEAR: 'ASNAAF_LOGIN_CLEAR',
	},

	FORGET_PASSWORD: {
		REQUEST: 'USER_FORGET_PASSWORD_REQUEST',
		SUCCESS: 'USER_FORGET_PASSWORD_SUCCESS',
		FAILURE: 'USER_FORGET_PASSWORD_FAILURE',
		CLEAR: 'USER_FORGET_PASSWORD_CLEAR',
	},
	RESET_PASSWORD: {
		REQUEST: 'USER_RESET_PASS_REQUEST',
		SUCCESS: 'USER_RESET_PASS_SUCCESS',
		FAILURE: 'USER_RESET_PASS_FAILURE',
	},
	REGISTER: {
		REQUEST: 'USER_REGISTER_REQUEST',
	},

	CREATE_OTP: {
		REQUEST: 'USER_CREATE_OTP_REQUEST',
		SUCCESS: 'USER_CREATE_OTP_SUCCESS',
		FAILURE: 'USER_CREATE_OTP_FAILURE',
	},
	GET_PROFILE: {
		REQUEST: 'USER_GET_PROFILE_REQUEST',
		SUCCESS: 'USER_GET_PROFILE_SUCCESS',
		FAILURE: 'USER_GET_PROFILE_FAILURE',
	},
	PROFILE: {
		REQUEST: 'USER_PROFILE_REQUEST',
		SUCCESS: 'USER_PROFILE_SUCCESS',
		FAILURE: 'USER_PROFILE_FAILURE',
	},
	PROFILE_UPDATE: {
		REQUEST: 'USER_PROFILE_UPDATE_REQUEST',
		SUCCESS: 'USER_PROFILE_UPDATE_SUCCESS',
		FAILURE: 'USER_PROFILE_UPDATE_FAILURE',
		CLEAR: 'USER_PROFILE_UPDATE_CLEAR',
	},
	CHANGE_NUMBER_OTP: {
		REQUEST: 'USER_CHANGE_NUMBER_OTP_REQUEST',
		SUCCESS: 'USER_CHANGE_NUMBER_OTP_SUCCESS',
		FAILURE: 'USER_CHANGE_NUMBER_OTP_FAILURE',
		CLEAR: 'USER_CHANGE_NUMBER_OTP_CLEAR',
	},
	CHANGE_NUMBER_OTP_CONFIRM: {
		REQUEST: 'USER_CHANGE_NUMBER_OTP_CONFIRM_REQUEST',
		SUCCESS: 'USER_CHANGE_NUMBER_OTP_CONFIRM_SUCCESS',
		FAILURE: 'USER_CHANGE_NUMBER_OTP_CONFIRM_FAILURE',
		CLEAR: 'USER_CHANGE_NUMBER_OTP_CONFIRM_CLEAR',
	},
	WIZARD: {
		REQUEST: 'WIZARD_REQUEST',
		SUCCESS: 'WIZARD_SUCCESS',
		FAILURE: 'WIZARD_FAILURE',
		CLEAR: 'WIZARD_CLEAR',
	},
	REGISTER_FRESH: {
		REQUEST: 'REGISTER_FRESH_REQUEST',
		SUCCESS: 'REGISTER_FRESH_SUCCESS',
		FAILURE: 'REGISTER_FRESH_FAILURE',
		CLEAR: 'REGISTER_FRESH_CLEAR',
	},
	UPDATE_PROFILE: {
		REQUEST: 'UPDATE_PROFILE_REQUEST',
		SUCCESS: 'UPDATE_PROFILE_SUCCESS',
		FAILURE: 'UPDATE_PROFILE_FAILURE',
		CLEAR: 'UPDATE_PROFILE_CLEAR',
	},
};

export default userTypes;
